import { KeyTerm } from "./KeyTerm";

export * from "./KeyTerm";

export default KeyTerm;
